import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { waLink, CONTACT } from "@/data/site";
import { track } from "@/lib/api";
import { scrollTo } from "@/components/pp/Navbar";

export const WhatsAppFAB = () => (
  <motion.a
    href={waLink()} target="_blank" rel="noopener noreferrer"
    onClick={() => track("whatsapp_click", { location: "fab" })}
    data-testid="whatsapp-fab"
    initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.4, type: "spring" }}
    whileHover={{ scale: 1.08 }}
    className="hidden md:grid fixed bottom-7 right-7 z-[75] h-14 w-14 place-items-center rounded-full bg-[#25D366] text-black shadow-[0_8px_30px_rgba(37,211,102,0.5)]"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle size={26} />
    <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/30" />
  </motion.a>
);

export const MobileBottomBar = () => (
  <div className="md:hidden fixed bottom-0 inset-x-0 z-[75] pp-glass border-t border-white/10 grid grid-cols-3" data-testid="mobile-bottom-bar">
    <a
      href={`tel:${CONTACT.phone}`} onClick={() => track("call_click", { location: "bottom_bar" })}
      className="flex flex-col items-center justify-center py-3 gap-1 text-slate-200 active:bg-white/5" data-testid="bottombar-call"
    >
      <Phone size={18} /> <span className="text-[11px] font-medium">Call</span>
    </a>
    <a
      href={waLink()} target="_blank" rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { location: "bottom_bar" })}
      className="flex flex-col items-center justify-center py-3 gap-1 text-[#25D366] border-x border-white/10 active:bg-white/5" data-testid="bottombar-whatsapp"
    >
      <MessageCircle size={18} /> <span className="text-[11px] font-medium">WhatsApp</span>
    </a>
    <button
      onClick={() => { track("cta_click", { cta: "get_quote", location: "bottom_bar" }); scrollTo("planner"); }}
      className="flex flex-col items-center justify-center py-3 gap-1 text-[#f59e0b] active:bg-white/5" data-testid="bottombar-quote"
    >
      <FileText size={18} /> <span className="text-[11px] font-medium">Get Quote</span>
    </button>
  </div>
);
